module.exports = __webpack_public_path__ + "img/EG.d2148b2c.svg";